module.exports = __webpack_public_path__ + "static/screen_cropped_1s-d0784b48bf620e156a399212179b642e.mp4";